import { render, staticRenderFns } from "./4-Store.vue?vue&type=template&id=bf863ee0&scoped=true"
import script from "./4-Store.vue?vue&type=script&lang=js"
export * from "./4-Store.vue?vue&type=script&lang=js"
import style0 from "./4-Store.vue?vue&type=style&index=0&id=bf863ee0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf863ee0",
  null
  
)

export default component.exports